// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"f3e50f80","223":"8e155aca","507":"a95165b4"}[chunkId] + ".chunk.js";
};